import Vue from 'vue';
import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
import Locales from '../assets/translations.js';

import permissions from './modules/permissions';
import users from './modules/users';
import offers from './modules/offers';
import offersApply from './modules/offersApply';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  modules: {
    permissions,
    users,
    offers,
    offersApply
  }
});

const Language = window.localStorage.getItem('Language') || 'es';
Vue.use(vuexI18n.plugin, store);
Vue.i18n.add('en', Locales.en);
Vue.i18n.add('es', Locales.es);
Vue.i18n.set(Language);

export default store;
